module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "modal",
    staticClass: "modal",
    attrs: {
      "id": "loginModal",
      "data-keyboard": "false",
      "data-backdrop": "static"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.register.ssoMissingData')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.registerUser($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.username')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": _vm.username
    },
    on: {
      "input": _vm.updateRegisterUsername
    }
  }), _vm._v(" "), (_vm.usernameInputErr) ? _c('span', {
    staticClass: "text-danger mb-20"
  }, [_vm._v(_vm._s(_vm.$t('pages.register.ssoMissingDataEmpty')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "studentId"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.studentId')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": _vm.studentId
    },
    on: {
      "input": _vm.updateRegisterStudentId
    }
  }), _vm._v(" "), (_vm.studentIdInputErr) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('pages.register.ssoMissingDataEmpty')))]) : _vm._e(), _vm._v(" "), (_vm.studentIdInputRgxErr) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('pages.register.ssoMissingDataStudentIdInvalid')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.setUsernameAndStudentId
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('pages.register.ssoMissingDataSubmit')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "submit",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('pages.userIconInHeader.signOut')) + "\n              ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-default color-palette-box k6-box"
  }, [_c('div', {
    staticClass: "box-header with-border k6-box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("pages.group.welcomeMessage2")))]), _vm._v(" "), (_vm.jeAdmin) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.colapseCreateGroup(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pages.adminpanel.group.createPrompt')))]) : _vm._e()]), _vm._v(" "), (!_vm.colCG) ? _c('div', {
    staticClass: "small-box-footer"
  }, [_c('br'), _vm._v(" "), _c('creategroup')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupList.myGroups), function(group, jIndeks) {
    return (_vm.jeAdmin || group.public) ? _c('div', {
      key: jIndeks,
      staticClass: "small-box info-box containter-full",
      class: [group.groupColor !== null ? group.groupColor : _vm.defaultGColor, group.isPending ? '' : 'group-box']
    }, [_c('GroupCard', {
      attrs: {
        "group": group,
        "jIndeks": jIndeks,
        "showYear": true,
        "groupListLength": _vm.groupList.archived.length + _vm.groupList.myGroups.length + _vm.groupList.otherGroups.length
      }
    }), _vm._v(" "), (group.showEdit) ? _c('editgroup', {
      attrs: {
        "group": group
      }
    }) : _vm._e(), _vm._v(" "), (group.showEditYear) ? _c('edityear', {
      attrs: {
        "year": group
      }
    }) : _vm._e(), _vm._v(" "), (group.showCreateYear) ? _c('createyear', {
      attrs: {
        "year": group
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2), _vm._v(" "), (_vm.groupList.otherGroups && _vm.groupList.otherGroups.length > 0) ? _c('div', {
    staticClass: "box box-default color-palette-box k6-box"
  }, [_c('div', {
    staticClass: "box-header with-border k6-box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("pages.group.welcomeMessage")))])]), _vm._v(" "), _vm._l((_vm.groupList.otherGroups), function(group, jIndeks) {
    return (_vm.jeAdmin || group.public) ? _c('div', {
      key: jIndeks,
      staticClass: "small-box info-box containter-full",
      class: [group.groupColor !== null ? group.groupColor : _vm.defaultGColor, _vm.jeAdmin ? 'group-box' : '']
    }, [_c('GroupCard', {
      attrs: {
        "group": group,
        "jIndeks": jIndeks + _vm.groupList.myGroups.length,
        "showYear": true,
        "groupListLength": _vm.groupList.archived.length + _vm.groupList.myGroups.length + _vm.groupList.otherGroups.length
      }
    }), _vm._v(" "), (group.showEdit) ? _c('editgroup', {
      attrs: {
        "group": group
      }
    }) : _vm._e(), _vm._v(" "), (group.showEditYear) ? _c('edityear', {
      attrs: {
        "year": group
      }
    }) : _vm._e(), _vm._v(" "), (group.showCreateYear) ? _c('createyear', {
      attrs: {
        "year": group
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.jeAdmin && _vm.groupList.archived && _vm.groupList.archived.length > 0) ? _c('div', {
    staticClass: "box box-default color-palette-box k6-box"
  }, [_c('div', {
    staticClass: "box-header with-border k6-box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("pages.group.welcomeMessage3")))])]), _vm._v(" "), _vm._l((_vm.groupList.archived), function(group, jIndeks) {
    return (_vm.jeAdmin || group.public) ? _c('div', {
      key: jIndeks,
      staticClass: "small-box info-box containter-full",
      class: [group.groupColor !== null ? group.groupColor : _vm.defaultGColor, _vm.jeAdmin ? 'group-box' : '']
    }, [_c('GroupCard', {
      attrs: {
        "group": group,
        "showYear": true,
        "jIndeks": jIndeks + _vm.groupList.myGroups.length + _vm.groupList.otherGroups.length,
        "groupListLength": _vm.groupList.archived.length + _vm.groupList.myGroups.length + _vm.groupList.otherGroups.length
      }
    }), _vm._v(" "), (group.showEdit) ? _c('editgroup', {
      attrs: {
        "group": group
      }
    }) : _vm._e(), _vm._v(" "), (group.showEditYear) ? _c('edityear', {
      attrs: {
        "year": group
      }
    }) : _vm._e(), _vm._v(" "), (group.showCreateYear) ? _c('createyear', {
      attrs: {
        "year": group
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38057edb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38057edb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/groups-v2/GroupList.vue
// module id = 1431
// module chunks = 1